import { render } from "./post_register.vue?vue&type=template&id=43504bc2&scoped=true&ts=true"
import script from "./post_register.vue?vue&type=script&lang=ts"
export * from "./post_register.vue?vue&type=script&lang=ts"

import "./post_register.vue?vue&type=style&index=0&id=43504bc2&scoped=true&lang=css"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43504bc2"]])

export default __exports__